import moment from 'moment';

export const formatTimestamp = (value: string | null | undefined): string =>
  value ? moment(value).format('MMM D, YYYY HH:mm:ss') : '—';

export const formatRelative = (value: string | null | undefined): string =>
  value ? moment(value).fromNow() : '—';

/** A capped count comes back as null rather than an approximation. */
export const formatCount = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : value.toLocaleString();

export const formatDuration = (seconds: number | null | undefined): string => {
  if (seconds === null || seconds === undefined) return '—';
  if (seconds < 1) return `${Math.round(seconds * 1000)}ms`;
  if (seconds < 60) return `${seconds.toFixed(2)}s`;

  return moment.duration(seconds, 'seconds').humanize();
};
